<template>
  <div class="deliveryprocess">
    <Header />
    <div class="container">
      <div class="homedelivery_section">
        <p class="delivery-text">{{$t('deliver_gold')}}</p>
        <span class="homedelivery-icon">
          <img src="../assets/images/Homedelivery_1.svg" />
        </span>
      </div>
      <div class="deliveryaction">
        <div class="worktext">{{$t('howitwork')}}</div>
        <div class="deliveryitem">
          <div class="deliveryicon">
            <img src="../assets/images/icons1.png" />
          </div>
          <div class="deliveryname">{{$t('choosegoldcoin')}}</div>
        </div>
        <div class="deliveryitem">
          <div class="deliveryicon">
            <img src="../assets/images/icons2.png" />
          </div>
          <div class="deliveryname">{{$t('paymakingcharges')}}</div>
        </div>
        <div class="deliveryitem">
          <div class="deliveryicon">
            <img src="../assets/images/icons3.png" />
          </div>
          <div class="deliveryname">{{$t('gethomedelivery')}}</div>
        </div>
      </div>
      <div class="select_gold">
        <div class="safe-buygold">
          <h4>{{$t('gold_balance')}}</h4>
          <CalculateGoldAmount />
        </div>
        <div v-for="(goldItems, index) in productList" :key="index">
          <GoldProducts :goldItems="goldItems" />
        </div>
        <div class="more_data">
        <span v-if="(hideMoreButton) && (productList.length)">No more items</span>
        <Button v-if="!hideMoreButton" class="more-btn" @click="moreProductList">+ more</Button>
        </div>
        </div>
    </div>
    <div class="loader" v-if="loading">
      <img src="https://cdn.mall91.com/9ca91a3c-b750-4f95-854b-15588473cc97.gif" />
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import CalculateGoldAmount from "../components/CalculateGoldAmount";
import GoldProducts from "../components/GoldProducts";

export default {
  name: "DeliveryProcess",
  components: {
    Header,
    GoldProducts,
    CalculateGoldAmount,
  },

  data() {
    return {
      productList: [],
      hideMoreButton:false,
      loading: false,
      pagination: 0
    };
  },
  methods: {
    moreProductList(){
       this.loading = !this.loading;
       this.$store
      .dispatch({ type: "deliveryGoldProducts", payload: this.pagination })
      .then(data => {
        this.loading = !this.loading;
        this.productList =  this.productList.concat(data.data);
        if (data.data.length) {
        this.pagination = this.pagination + 6;
        }
        else{
          this.hideMoreButton=true;
        }
      })
      .catch(err => {
        this.loading = !this.loading;
        toaster(this, this.$t("somethingwentwrong"), "top-left", 3000);
      });
    },
  },
  mounted() {
    this.moreProductList()
     }
};
</script>